import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@components/common/command"

import { Popover, PopoverContent, PopoverTrigger } from "@components/common/popover"
import { ChevronsUpDown } from "lucide-react"
import { DictType } from "@pma/types"
import { cn } from "@pma/utils/helpers"
import { useMutation, useQuery } from "@tanstack/react-query"

import { Dispatch, SetStateAction, useEffect, useState } from "react"
import useTranslator from "@hooks/use-translator"
import { getDictionaryItemWithoutContext } from "@pma/utils/utils"
import { useAuth } from "@pma/stores/auth-store"
import axios from "axios"
import { EDIT_PROJECT_BY_CURRENT_USER_ENDPOINT, SERVER_URL } from "@pma/utils/api-routes"
import { ACCESS_TOKEN, queryClient } from "@pma/utils/constants"
import { parseCookies } from "nookies"
import { useSearchParams } from "react-router-dom"
import { toast } from "@pma/hooks/use-toast"
import { Separator } from "@components/common/separator"
import AddNeighborhoodForm from "./add-neighborhood-form"

interface Props {
  setEditMode:any
  value: any
  setValue:any
  projectId:number
}
const NeighborhoodSelector = ({ value ,projectId,setEditMode,setValue}: Props) => {
  // const [neighborhood,setNeighborhood] = useState(value ?? null)
  const [isOpen,setIsOpen] = useState(false)
  const { authConfig } = useAuth()
  const userId = authConfig?.id;

  const orgId = authConfig?.last_organization_id
    const [searchParam] = useSearchParams();
  
  const newParams = new URLSearchParams(searchParam); 

  const { translate, locale } = useTranslator()
  const accessToken = parseCookies()[ACCESS_TOKEN];

  const { data: neighborhoods, refetch } = useQuery({
    queryKey: ["neighborhoods"],
    queryFn: () => getDictionaryItemWithoutContext("/dictionary/water/neighborhood", orgId),
  })
  
  // const updateProjectDetails = async () => {
  //     let payload = {
  //       project_id: projectId,
  //       user_id: userId,
  //       neighborhood_id:neighborhood
  //     };
        
  //     const response = await axios.post(
  //       SERVER_URL + EDIT_PROJECT_BY_CURRENT_USER_ENDPOINT,
  //       payload,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //           "Content-Type": "application/json",
  //         },
  //       },
  //     );
  
  //     return response.data;
  //   };
  
  //   const updateProjectDetailsMutation = useMutation({
      
  //     mutationFn: updateProjectDetails,
  //     onSuccess: (data) => {
  //       // Revalidate project details
  //       queryClient.invalidateQueries({ queryKey: ["get-project"] })
  //       setEditMode(false)
  //     },
  //     onError: (error) => {
  //       toast({
  //         title: "Error",
  //         description: (
  //           <pre className="mt-2 w-[340px] rounded-md p-4">
  //             <code className="animate-pulse text-white">
  //               {translate(`Error occurred while updating `)}
  //             </code>
  //           </pre>
  //         ),
  //         variant: "error",
  //       });
  //     },
  //   });



  return (
    <div className=''>
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <div>
          <PopoverTrigger className='flex items-center justify-between rounded-md border p-1.5 text-sm'>
            <div className=''>
              {value ? (
                <div className='w-[23ch] overflow-hidden truncate text-ellipsis p-1 text-left text-xs font-semibold capitalize'>
                  {neighborhoods?.find((val:any)=>Number(val.id)===Number(value))?.name}
                </div>
              ) : (
                translate("Select Neighborhood")
              )}
            </div>
            <ChevronsUpDown size={12} />
          </PopoverTrigger>
        </div>
        <PopoverContent className='p-0'>
          <Command>
            <CommandInput placeholder={translate("Search neighborhood") + "..."} />
            <CommandList>
              <CommandEmpty>{translate("No neighborhood found")}.</CommandEmpty>
              <CommandGroup>
                {neighborhoods?.map((hood: DictType, index: number) => (
                
                    <CommandItem
                      key={hood.id}
                      value={value ? neighborhoods.find((val:any)=>Number(val.id)===Number(value)).id  : ''}
                      onSelect={() => {
                        setValue(hood.id)
                        // setIsOpen(false)
                      }}
                      //   onSelect={() => {
                      //     field.onChange({
                      //       name: neighborhood?.name,
                      //       id: neighborhood?.id,
                      //     });
                      //   }}
                      
                      className={cn(
                        "my-1 capitalize",
                        neighborhoods.find((val:any)=>Number(val.id)===Number(value)) && "bg-secondary/30 text-black",
                      )}
                    >
                      {hood.name}
                    </CommandItem>
                
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
          <div className='px-2 pb-2'>
            <Separator />
            <AddNeighborhoodForm refetch={refetch} />
          </div>
        </PopoverContent>
      </Popover>
    </div>
  )
}

export default NeighborhoodSelector
